module.exports = __webpack_public_path__ + "static/media/S5.cc6f83bc.png";